import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import * as utils from "../Utils/comman";

export const ProtectedRoute = () => {
    let is_auth = utils.isAuthenticated();
    return is_auth ? <Outlet /> : <Navigate to="/" />;
};
